export const routerPath = {
  root: '/global-settings',
};

export const PENDING = 'PENDING';
